import { classNames } from "lib/utils";
import _ from "lodash";

interface Props {}

const DefaultTag = ({}: Props) => {
  return (
    <div
      className={classNames("flex w-min items-center rounded-ms bg-oldgray-200 px-6 py-4 text-10-10 text-oldgray-800")}
    >
      default
    </div>
  );
};

export default DefaultTag;
